import { Fragment, useEffect, useState } from "react";
import { TitleHeader } from "../../components";
import { Button, Form, Input, notification, Switch } from "antd";
import { executeUpdate } from "../../api/sistema";
import { isAsistenciaEnabled } from "../../api/auxiliar";

function Configuracion() {
  const [isLoading, setIsLoading] = useState(false);
  const [dataToPage, setDataToPage] = useState({
    asistenciaEnabled: false,
    porSedeEnabled: false,
    porPeriodoEnabled: false
  });

  const fetchDataToPage = async () => {
    setIsLoading(true);

    isAsistenciaEnabled()
      .then((res) => {
        setDataToPage({
          asistenciaEnabled: res.payload.asistenciaEnabled,
          porSedeEnabled: res.payload.porSedeEnabled,
          porPeriodoEnabled: res.payload.porPeriodoEnabled
        });
      })
      .catch((err) => {
        notification.error({
          message: "Problemas con la solicitud",
          description: err.message
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchDataToPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFinish = (values) => {
    sendDataToServer(values);
  };

  const sendDataToServer = async (data) => {
    executeUpdate(
      {
        collection: "sys_config",
        nombreid: "configId",
        valorid: "configId"
      },
      {
        claveSistema: data.claveSistema
      }
    )
      .then((res) => {
        if (res.success) {
          notification.success({
            message: "Operación exitosa",
            description: `Se ha actualizado la contraseña satistactoriamente.`
          });
        }
      })
      .catch(() => {
        notification.error({
          message: "Operación no válida",
          description: `No se pudo actualizar el estado, comuníquese con el administrador.`
        });
      });
  };

  const onChangeState = (value) => {
    executeUpdate(
      {
        collection: "sys_config",
        nombreid: "configId",
        valorid: "configId"
      },
      {
        asistenciaEnabled: value
      }
    )
      .then((res) => {
        if (res.success) {
          notification.success({
            message: "Operación exitosa",
            description: `Se ha guardado la configuración satistactoriamente.`
          });
          fetchDataToPage();
        }
      })
      .catch(() => {
        notification.error({
          message: "Operación no válida",
          description: `No se pudo actualizar el estado, comuníquese con el administrador.`
        });
      });
  };

  const onChangeSedeState = (value) => {
    executeUpdate(
      {
        collection: "sys_config",
        nombreid: "configId",
        valorid: "porSedeId"
      },
      {
        asistenciaEnabled: value
      }
    )
      .then((res) => {
        if (res.success) {
          notification.success({
            message: "Operación exitosa",
            description: `Se ha guardado la configuración por sede satistactoriamente.`
          });
          fetchDataToPage();
        }
      })
      .catch(() => {
        notification.error({
          message: "Operación no válida",
          description: `No se pudo actualizar el estado, comuníquese con el administrador.`
        });
      });
  };

  const onChangePeriodoState = (value) => {
    executeUpdate(
      {
        collection: "sys_config",
        nombreid: "configId",
        valorid: "porPeriodoId"
      },
      {
        asistenciaEnabled: value
      }
    )
      .then((res) => {
        if (res.success) {
          notification.success({
            message: "Operación exitosa",
            description: `Se ha guardado la configuración por periodo satistactoriamente.`
          });
          fetchDataToPage();
        }
      })
      .catch(() => {
        notification.error({
          message: "Operación no válida",
          description: `No se pudo actualizar el estado, comuníquese con el administrador.`
        });
      });
  };

  return (
    <Fragment>
      <TitleHeader title="Configuración" />

      <div className="w-full mb-6 md:w-1/4">
        <p className="font-semibold mb-3">Marcar asistencia habilitada</p>
        <Switch
          checked={dataToPage.asistenciaEnabled}
          onChange={onChangeState}
          loading={isLoading}
        />
      </div>

      <div className="w-full mb-6 md:w-1/4">
        <p className="font-semibold mb-3">Modo por sede habilitado</p>
        <Switch
          checked={dataToPage.porSedeEnabled}
          onChange={onChangeSedeState}
          loading={isLoading}
        />
      </div>

      <div className="w-full mb-6 md:w-1/4">
        <p className="font-semibold mb-3">Modo por periodo habilitado</p>
        <Switch
          checked={dataToPage.porPeriodoEnabled}
          onChange={onChangePeriodoState}
          loading={isLoading}
        />
      </div>

      <div className="w-full md:w-1/4">
        <Form initialValues={{ remember: true }} onFinish={onFinish} layout="vertical">
          <Form.Item
            label="Actualizar clave de sistema"
            name="claveSistema"
            rules={[
              {
                required: true,
                message: "La clave de sistema es necesario"
              }
            ]}
          >
            <Input allowClear type="password" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" block htmlType="submit">
              Actualizar
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Fragment>
  );
}

export default Configuracion;
